@import 'styles/blaze/mixins';

.variantContainer {
  position: relative;
  width: var(--inner-preview-width, 100%);
  max-width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.blurred {
  width: 100%;
  height: 100%;
  @include filter-blur(8px);
  box-sizing: border-box;
}

.blogLayout,
.newsletterLayout {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px 10px 10px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.variantImageSlot {
  width: 100%;
  aspect-ratio: 230 / 126;
  border-radius: 8px;
  overflow: hidden;
  background: var(--dark-8);
  flex-shrink: 0;
}

.variantImage {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.variantImagePlaceholder {
  width: 100%;
  height: 100%;
}

.variantTitle {
  font-family: 'Söhne', Inter, serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.15;
  color: var(--dark-80);
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  flex-shrink: 0;
}

.variantDate {
  font-family: Inter, sans-serif;
  font-size: 11px;
  color: var(--dark-40);
  flex-shrink: 0;
}

.variantBody {
  font-family: Inter, sans-serif;
  font-size: 11px;
  line-height: 1.4;
  color: var(--dark-60);
  flex: 1 1 auto;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 8;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
}

.variantIndicator {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  padding: 8px;
}
